import { Send, Loader2 } from 'lucide-react';
import React, { useState, useCallback } from 'react';


const MISSION_GUID = 'c1ee9d03-9aaa-4f5c-9b3e-b0234e21a699';
const EXAMPLE_PAYLOAD = JSON.stringify({
  "Customer": "111363_13",
  "current_balance": 550.23,
  "credit_history": "D",
  "status": "Active",
  "applications": {
    "hasWATER": 1,
    "hasSEWER": 1,
    "hasTRASH/RECYCLING": 0,
    "hasDRAINAGE": 0
  },
  "work_orders": [
    {
      "work_order": "2018-561189",
      "status": "COMPLETED",
      "description": "CV BEGIN SERVICE",
      "date": 20190102
    },
    {
      "work_order": "2024-6201957326",
      "status": "COMPLETED",
      "description": "PROMISE TO PAY",
      "date": 20240915,
      "notes": [
        {
          "date": "2024-09-15T10:38:55",
          "note": "Customer promised to pay by 10/1",
          "sequence": 1
        }
      ]
    },
    {
      "work_order": "2024-6201957336",
      "status": "COMPLETED",
      "description": "IVR CALL - PAST DUE",
      "date": 20241015,
      "notes": []
    },
    {
      "work_order": "2024-6201957346",
      "status": "OPEN",
      "description": "IVR CALL - PAST DUE",
      "date": 20241115,
      "notes": []
    }
  ]
}, null, 2);

const MatchaAISummaryTool = () => {
  const [payload, setPayload] = useState(EXAMPLE_PAYLOAD);
  const [summary, setSummary] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = useCallback(async () => {
    setIsLoading(true);
    setError('');
    setSummary('');

    try {
      const response = await fetch('/api/matcha-summary', { // Proxied request
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ payload }), // Send the raw payload string
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API Error: ${response.status} ${response.statusText} - ${errorText}`);
      }

      const data = await response.json();
      setSummary(data.summary || 'No summary returned.');
    } catch (err) {
      console.error('Error fetching summary:', err);
      setError(err.message || 'Failed to fetch summary.');
    }
    setIsLoading(false);
  }, [payload]);

  return (
    <div className="p-4 space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-gray-800">MatchaAI Summary Tool</h3>
        <p className="text-sm text-gray-600">
          Mission ID: <span className="font-mono bg-gray-100 p-1 rounded text-xs">{MISSION_GUID}</span>
        </p>
        <p className="text-xs text-gray-500 mt-1">
          This tool uses a secure backend proxy to interact with the MatchaAI API.
        </p>
      </div>

      <div>
        <label htmlFor="payload-input" className="block text-sm font-medium text-gray-700 mb-1">
          Payload (JSON format expected by the example, but can be any string for the API):
        </label>
        <textarea
          id="payload-input"
          rows={15}
          className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm font-mono"
          value={payload}
          onChange={(e) => setPayload(e.target.value)}
          placeholder="Enter payload here..."
        />
      </div>

      <button
        onClick={handleSubmit}
        disabled={isLoading}
        className="w-full flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 transition-colors duration-150"
      >
        {isLoading ? (
          <><Loader2 className="animate-spin h-5 w-5 mr-2" /> Generating...</>
        ) : (
          <><Send className="h-5 w-5 mr-2" /> Generate Summary</>
        )}
      </button>

      {error && (
        <div className="mt-4 p-3 bg-red-100 border border-red-300 text-red-700 rounded-md">
          <p className="font-semibold">Error:</p>
          <p className="text-sm whitespace-pre-wrap">{error}</p>
        </div>
      )}

      {summary && (
        <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-md">
          <p className="font-semibold text-green-800">Summary:</p>
          <pre className="text-sm text-gray-700 whitespace-pre-wrap bg-white p-2 rounded border border-gray-200 mt-1">{summary}</pre>
        </div>
      )}
    </div>
  );
};

export default MatchaAISummaryTool;
